import React from 'react';
import PropTypes from 'prop-types';

import './download-btn.scss';

const DownloadButton = ({ btnTitle, downloadUrl, white = false }) => {
  return (
    downloadUrl !== '' && (
      <a
        href={downloadUrl}
        target='_blank'
        rel='noopener noreferrer'
        download={downloadUrl}
      >
        <button className={`download__btn ${white ? 'white' : ''}`}>
          {btnTitle}
        </button>
      </a>
    )
  );
};

DownloadButton.propTypes = {
  downloadUrl: PropTypes.string,
  btnTitle: PropTypes.string,
  white: PropTypes.bool,
};

export default DownloadButton;
